<!-- 采购员业绩统计-海口-->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn search-picker">
            <div class="search-ctn">
                <div class="search-ctn-right">
                    <div class="search-name">仓库</div>
                    <el-select
                        v-model="searchData.WarehouseId"
                        :loading="loading"
                        class="search-item"
                        size="small"
                        filterable
                        clearable
                        remote
                        @visible-change="getWarehouse()"
                    >
                        <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index">
                            <span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                        </el-option>
                    </el-select>
                    <div class="search-name">订单来源</div>
                    <el-select
                        size="small"
                        class="search-item"
                        v-model="searchData.CusSources"
                        filterable
                        clearable
                        collapse-tags
                        reserve-keyword
                        multiple
                        @visible-change="cusSourceVisibleChange($event)"
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="optionItem in cusSourceList"
                            :key="optionItem.Value"
                            :data-msg="optionItem"
                            :label="optionItem.Text"
                            :value="optionItem.Value"
                        ></el-option>
                    </el-select>
                    <div class="search-name">开单部门</div>
                    <el-select
                        size="small"
                        class="search-item"
                        v-model="searchData.OrgIds"
                        filterable
                        clearable
                        collapse-tags
                        reserve-keyword
                        multiple
                        @visible-change="orgVisibleChange($event)"
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="optionItem in orgSearchData"
                            :key="optionItem.Id"
                            :data-msg="optionItem"
                            :label="optionItem.Name"
                            :value="optionItem.Id"
                        ></el-option>
                    </el-select>
                    <div class="search-name">采购员</div>
                    <el-select
                        v-model="searchData.SIds"
                        multiple
                        collapse-tags
                        size="small"
                        class="search-item"
                        filterable
                        placeholder="请选择"
                        @visible-change="siVisibleChange($event)"
                    >
                        <el-option v-for="(item, index) in sIdList" :key="index" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <div class="search-name">提交时间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                    ></el-date-picker>

                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="getPurchaseTableData">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <ux-grid
                    ref="multipleTable"
                    :data="tableSaleData"
                    border
                    style="width: 100%"
                    show-summary
                    :summary-method="getSummaries"
                    :sort-config="{ defaultSort: { field: 'RealSaleTotalAmount', order: 'desc' } }"
                >
                    <ux-table-column resizable fixed width="50px" type="index" sortable title="排名"></ux-table-column>
                    <ux-table-column resizable fixed min-width="100px" field="SName" title="采购员"></ux-table-column>
                    <ux-table-column resizable :title="item.OrgName" min-width="100px" v-for="(item, index) in header" :key="index">
                        <template slot-scope="scope">
                            <!-- <span v-for="(item2, index2) in scope.row.OrgtList" v-if="item.OrgName == item2.OrgName" :key="index2">
                                {{ item2.SaleTotal }}
                            </span> -->
                            <span v-for="(item2, index2) in scope.row.OrgtList" v-if="index == index2" :key="index2">
                                {{ item2.SaleTotal }}
                            </span>
                        </template>
                    </ux-table-column>

                    <ux-table-column resizable sortable width="110" fixed="right" field="SaleTotalAmount" title="采购总额"></ux-table-column>
                    <ux-table-column resizable sortable width="110" fixed="right" field="SaleOrderTotalCount" title="采购单数"></ux-table-column>
                    <ux-table-column resizable sortable width="120" fixed="right" field="GoodsTotalCount" title="商品总数"></ux-table-column>
                    <ux-table-column resizable sortable width="130" fixed="right" field="SaleReturnTotalAmount" title="采购退货总额"></ux-table-column>
                    <ux-table-column resizable sortable width="130" fixed="right" field="SaleReturnTotalCount" title="采购退货数"></ux-table-column>
                    <ux-table-column resizable sortable width="130" fixed="right" field="RealSaleTotalAmount" title="实际采购额"></ux-table-column>
                </ux-grid>
            </div>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            dateTimes: [],
            orgSearchData: [],
            WarehouseList: [],
            searchData: {
                OrgIds: [],
                SIds: [],
                CusSources: [],
                StartDate: '',
                EndDate: '',
                WarehouseId: ''
            },
            loading: false,
            sIdList: [],
            tableSaleData: [],
            tableSaleDataLength: 0,
            tablePurchaseData: [],
            cusSourceList: [],
            tablePurchaseDataLength: 0,
            header: [],
            selectDate: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 150);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 335);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ],
                //时间跨度不能超过1年
                onPick: ({ maxDate, minDate }) => {
                    // this.selectDate = minDate.getTime();
                    // if (maxDate) {
                    //     this.selectDate = '';
                    // }
                    // 当用户选择第一个日期时，记录选择的时间
                    if (minDate && !maxDate) {
                        this.selectDate = minDate.getTime();
                    } else {
                        // 当选择第二个日期或清空选择时，重置
                        this.selectDate = null;
                    }
                },
                disabledDate: time => {
                    // if (this.selectDate !== '') {
                    //     const one = 30 * 24 * 3600 * 1000 * 12;
                    //     const minTime = this.selectDate - one;
                    //     const maxTime = this.selectDate + one;
                    //     return time.getTime() < minTime || time.getTime() > maxTime;
                    // }
                    if (!this.selectDate) return false;
                    // // 避免使用固定天数（365 或 366）的毫秒数
                    // // 使用 new Date(start).setFullYear(start.getFullYear() + 1) 动态计算一年后的时间
                    // const start = new Date(this.selectDate);
                    // const oneYearLater = this.addOneYear(start);
                    // return time.getTime() < start.getTime() || time.getTime() > oneYearLater.getTime();
                    // 使用精确的毫秒计算，避免年份加减的边界问题
                    const oneYearMs = 365 * 24 * 60 * 60 * 1000;

                    // 计算允许的最小和最大范围
                    const minSelectable = this.selectDate - oneYearMs;
                    const maxSelectable = this.selectDate + oneYearMs;

                    // 判断当前时间是否在允许范围内
                    const timeMs = time.getTime();

                    // 允许选择边界日期（包括同一天）
                    // 这里的关键是使用 <= 和 >= 而不是 < 和 >
                    return timeMs < minSelectable || timeMs > maxSelectable;
                }
            }
        };
    },
    created() {
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        this.dateTimes.push(date1);
        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1];
        let date2 = new Date(year2, month2, 1, 0);
        this.dateTimes.unshift(date2);

        this.searchData.StartDate = date2;
        this.searchData.EndDate = date1;
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getPurchaseTableData();
    },
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];

            if (columns.length <= 8) return [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                } else if (index == 1) {
                    sums[index] = '';
                } else if (index < this.header.length + 2) {
                    let s = 0;
                    data.forEach((e, i) => {
                        if (e.OrgtList && e.OrgtList.length > 0)
                            e.OrgtList.forEach(ee => {
                                if (ee.OrgName == column.title) {
                                    s += ee.SaleTotal;
                                }
                            });
                    });
                    sums[index] = s.toFixed(2);
                } else {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        if (!(column.title == '采购单数' || column.title == '商品总数')) sums[index] = sums[index].toFixed(2);
                    } else {
                        sums[index] = '';
                    }
                }
            });

            return [sums];
        },
        // 重置表单
        resetSearch() {
            let that = this;
            that.searchData.SIds = [];
            that.searchData.OrgIds = [];
            that.searchData.CusSources = [];
            that.selectDate = '';
            that.dateTimes = [];

            let d = new Date();
            let year1, month1, day1;
            [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
            let date1 = new Date(year1, month1, day1, 0);
            that.dateTimes.push(date1);

            //前一天设定的日期时间
            let year2, month2, day2;
            d.setTime(d.getTime());
            [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
            let date2 = new Date(year2, month2, 1, 0);
            that.dateTimes.unshift(date2);

            that.searchData.StartDate = date2;
            that.searchData.EndDate = date1;
        },
        // 获取数据
        getPurchaseTableData() {
            if (this.searchData.StartDate == '' || this.searchData.EndDate == '') {
                this.$util.warningMsg('请选择创建时间');
            }
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/PurPerfStatH',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        this.tableSaleData = data.List;
                        this.tableSaleDataLength = res.count;
                        this.header = data.header;
                    } else if (res.errcode != 201 && !data) {
                        this.tableSaleData = [];
                        this.tableSaleDataLength = [];
                        this.header = [];
                    }
                    //刷新列配置,因为部门列是动态变化的，如果不刷新会影响到getSummaries的计算
                    this.$refs.multipleTable.refreshColumn();
                })
                .catch(() => {});
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.sIdList.length <= 1) {
                    that.$util.getPurchaserList().then(data => {
                        that.sIdList = data;
                    });
                }
            }
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
                const oneYearLater = this.addOneYear(new Date(this.searchData.StartDate));
                if (this.searchData.EndDate > oneYearLater) {
                    this.$util.warningMsg('选择的时间范围不能超过一年');
                    this.dateTimes = [];
                    this.selectDate = null;
                }
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgSearchData.length == 0)
                    that.$util.getParentOrgs().then(data => {
                        that.orgSearchData = data;
                    });
            }
        },
        cusSourceVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.cusSourceList.length == 0) {
                    that.$util.getPurOrderSetSources().then(data => {
                        if (data) {
                            that.cusSourceList = [...data, { Value: '-1', Text: '其他' }];
                        } else {
                            that.cusSourceList = [{ Value: '-1', Text: '其他' }];
                        }
                    });
                }
            }
        },
        getWarehouse() {
            if (this.WarehouseList.length <= 1) {
                this.$util.getWarehouse(1).then(data => {
                    this.WarehouseList = data;
                });
            }
        },
        addOneYear(date) {
            const result = new Date(date);
            result.setFullYear(result.getFullYear() + 1);
            return result;
        }
    }
};
</script>
<style lang="less">
.table-ctn {
    .elx-table--body-wrapper {
        .elx-body--row {
            td {
                height: 36px;
            }
        }
    }
}
</style>
